<div class="aca-ai-set">
  <p class="aca-ai-set__notice" *ngIf="failed() as failure"><mat-icon>info</mat-icon>{{ failure | translate }}</p>

  <ng-container *ngIf="settings() as s">
    <!-- ── on / off ──────────────────────────────────────────────────── -->
    <div class="aca-ai-set__head">
      <div>
        <h3 class="aca-set__cardtitle">{{ 'DMS.ASSISTANT.TITLE' | translate }}</h3>
        <p class="aca-set__cardnote">{{ 'DMS.ASSISTANT.INTRO' | translate }}</p>
        <p class="aca-ai-set__state" [class.aca-ai-set__state--on]="s.enabled">
          <span class="aca-ai-set__dot" aria-hidden="true"></span>
          {{ (s.enabled ? 'DMS.ASSISTANT.STATE_ON' : 'DMS.ASSISTANT.STATE_OFF') | translate }}
        </p>
      </div>
      <label class="aca-ai-set__switch">
        <input type="checkbox" [checked]="s.enabled" [disabled]="saving()" (change)="setEnabled($any($event.target).checked)" />
        <span class="aca-ai-set__track" aria-hidden="true"></span>
        <span>{{ (s.enabled ? 'DMS.ASSISTANT.ON' : 'DMS.ASSISTANT.OFF') | translate }}</span>
      </label>
    </div>

    <!-- ── providers ─────────────────────────────────────────────────── -->
    <section class="aca-ai-set__block">
      <div class="aca-ai-set__blockhead">
        <h4>{{ 'DMS.ASSISTANT.PROVIDERS' | translate }}</h4>
        <span>{{ 'DMS.ASSISTANT.PROVIDERS_HINT' | translate }}</span>
        <button type="button" class="aca-ai-set__ghost aca-ai-set__ghost--end" (click)="add()" [disabled]="!!draft()">
          <mat-icon>add</mat-icon>{{ 'DMS.ASSISTANT.ADD' | translate }}
        </button>
      </div>

      <div class="aca-ai-set__list">
        <div class="aca-ai-set__prov" *ngFor="let p of s.providers; let i = index" [class.aca-ai-set__prov--default]="p.id === s.defaultProviderId">
          <span class="aca-ai-set__logo" aria-hidden="true">{{ initials(p) }}</span>
          <span class="aca-ai-set__provbody">
            <span class="aca-ai-set__provname">
              {{ p.name }}
              <span class="aca-ai-set__tag" [ngClass]="p.location === 'local' ? 'aca-ai-set__tag--local' : 'aca-ai-set__tag--cloud'">
                {{ (p.location === 'local' ? 'DMS.ASSISTANT.LOCAL' : 'DMS.ASSISTANT.CLOUD') | translate }}
              </span>
              <span class="aca-ai-set__tag" [ngClass]="'aca-ai-set__tag--' + p.status">{{ statusLabel(p.status) | translate }}</span>
              <span class="aca-ai-set__tag aca-ai-set__tag--default" *ngIf="p.id === s.defaultProviderId">{{
                'DMS.ASSISTANT.DEFAULT' | translate
              }}</span>
            </span>
            <span class="aca-ai-set__provmeta">{{ p.model || ('DMS.ASSISTANT.NO_MODEL' | translate) }} · {{ p.url }}</span>
          </span>
          <span class="aca-ai-set__provside">
            <button
              type="button"
              class="aca-ai-set__ghost"
              *ngIf="p.id !== s.defaultProviderId && p.model"
              (click)="setDefault(p)"
              [disabled]="saving()"
            >
              {{ 'DMS.ASSISTANT.MAKE_DEFAULT' | translate }}
            </button>
            <button type="button" class="aca-ai-set__ghost" (click)="edit(p, i)" [disabled]="!!draft()">
              {{ 'DMS.ASSISTANT.EDIT' | translate }}
            </button>
            <button type="button" class="aca-ai-set__ghost aca-ai-set__ghost--danger" (click)="remove(p)" [disabled]="!!draft() || saving()">
              {{ (confirmRemove() === p.id ? 'DMS.ASSISTANT.CONFIRM_REMOVE' : 'DMS.ASSISTANT.REMOVE') | translate }}
            </button>
          </span>
        </div>
        <p class="aca-ai-set__empty" *ngIf="!s.providers.length">{{ 'DMS.ASSISTANT.NO_PROVIDERS' | translate }}</p>
      </div>

      <!-- the editor -->
      <div class="aca-ai-set__editor" *ngIf="draft() as d">
        <p class="aca-ai-set__editortitle">{{ (d.id ? 'DMS.ASSISTANT.EDIT_TITLE' : 'DMS.ASSISTANT.ADD_TITLE') | translate }}</p>
        <div class="aca-ai-set__fields">
          <label class="aca-ai-set__field">
            <span>{{ 'DMS.ASSISTANT.TYPE' | translate }}</span>
            <select [ngModel]="d.type" (ngModelChange)="changeType($event)">
              <option *ngFor="let k of kinds" [value]="k.id">{{ k.label }}</option>
            </select>
          </label>
          <label class="aca-ai-set__field">
            <span>{{ 'DMS.ASSISTANT.NAME' | translate }}</span>
            <input [ngModel]="d.name" (ngModelChange)="patchDraft({ name: $event })" [placeholder]="kindOf(d.type).label" />
          </label>
          <label class="aca-ai-set__field aca-ai-set__field--wide">
            <span>{{ 'DMS.ASSISTANT.URL' | translate }}</span>
            <input [ngModel]="d.url" (ngModelChange)="patchDraft({ url: $event })" (blur)="loadModels()" spellcheck="false" />
            <small [class.aca-ai-set__warn]="d.location === 'cloud'">
              {{ (d.location === 'local' ? 'DMS.ASSISTANT.LOCAL_HINT' : 'DMS.ASSISTANT.CLOUD_HINT') | translate }}
            </small>
          </label>
          <label class="aca-ai-set__field" *ngIf="kindOf(d.type).location === 'either'">
            <span>{{ 'DMS.ASSISTANT.WHERE' | translate }}</span>
            <select [ngModel]="d.location" (ngModelChange)="patchDraft({ location: $event })">
              <option value="local">{{ 'DMS.ASSISTANT.LOCAL' | translate }}</option>
              <option value="cloud">{{ 'DMS.ASSISTANT.CLOUD' | translate }}</option>
            </select>
          </label>
          <label class="aca-ai-set__field" *ngIf="kindOf(d.type).key || d.type === 'compat'">
            <span>API key</span>
            <input
              type="password"
              [(ngModel)]="keyDraft"
              (blur)="loadModels()"
              autocomplete="off"
              [placeholder]="d.keyMask || ('DMS.ASSISTANT.KEY_PLACEHOLDER' | translate)"
            />
            <small>{{ 'DMS.ASSISTANT.KEY_HINT' | translate }}</small>
          </label>
          <div class="aca-ai-set__field">
            <label for="aca-ai-model">{{ 'DMS.ASSISTANT.MODEL' | translate }}</label>
            <select id="aca-ai-model" *ngIf="models().length; else typed" [ngModel]="d.model" (ngModelChange)="patchDraft({ model: $event })">
              <option value="" disabled>{{ 'DMS.ASSISTANT.PICK_MODEL' | translate }}</option>
              <option *ngFor="let m of models()" [value]="m">{{ m }}</option>
            </select>
            <ng-template #typed>
              <input id="aca-ai-model" [ngModel]="d.model" (ngModelChange)="patchDraft({ model: $event })" spellcheck="false" />
            </ng-template>
            <small>
              <button type="button" class="aca-ai-set__link" (click)="loadModels()" [disabled]="modelsBusy()">
                {{ (modelsBusy() ? 'DMS.ASSISTANT.LOADING_MODELS' : 'DMS.ASSISTANT.LOAD_MODELS') | translate }}
              </button>
              <span class="aca-ai-set__warn" *ngIf="modelsError() as e"> · {{ e }}</span>
            </small>
          </div>
        </div>

        <!-- the four checks, drawn the way the assistant draws its steps -->
        <ol class="aca-ai-steps" *ngIf="testing() || result()">
          <li class="aca-ai-steps__step aca-ai-steps__step--run" *ngIf="testing()">
            <span class="aca-ai-steps__dot" aria-hidden="true"></span>
            <span class="aca-ai-steps__main"
              ><strong>{{ 'DMS.ASSISTANT.TESTING' | translate }}</strong></span
            >
          </li>
          <ng-container *ngIf="result() as r">
            <li
              class="aca-ai-steps__step"
              *ngFor="let step of r.steps"
              [ngClass]="step.ok ? (step.warn ? 'aca-ai-steps__step--warn' : 'aca-ai-steps__step--done') : 'aca-ai-steps__step--fail'"
            >
              <span class="aca-ai-steps__dot" aria-hidden="true"></span>
              <span class="aca-ai-steps__main">
                <span class="aca-ai-steps__head"
                  ><strong>{{ step.title }}</strong
                  ><em>{{ step.ms / 1000 | number: '1.1-1' }} s</em></span
                >
                <span class="aca-ai-steps__out">{{ step.detail }}</span>
              </span>
            </li>
          </ng-container>
        </ol>

        <div class="aca-ai-set__actions">
          <button type="button" class="aca-ai-set__ghost" (click)="runTest()" [disabled]="testing() || !d.model">
            <mat-icon>network_check</mat-icon>{{ 'DMS.ASSISTANT.TEST' | translate }}
          </button>
          <span class="aca-ai-set__spacer"></span>
          <button type="button" class="aca-ai-set__ghost" (click)="closeDraft()">{{ 'DMS.ASSISTANT.CANCEL' | translate }}</button>
          <button type="button" class="aca-set__save" (click)="saveDraft()" [disabled]="saving() || !d.url">
            {{ 'DMS.ASSISTANT.SAVE' | translate }}
          </button>
        </div>
      </div>
    </section>

    <!-- ── rules ─────────────────────────────────────────────────────── -->
    <section class="aca-ai-set__block">
      <div class="aca-ai-set__blockhead">
        <h4>{{ 'DMS.ASSISTANT.RULES' | translate }}</h4>
      </div>
      <div class="aca-ai-set__rules">
        <div class="aca-ai-set__rule">
          <div>
            <strong>{{ 'DMS.ASSISTANT.WHO' | translate }}</strong
            ><span>{{ 'DMS.ASSISTANT.WHO_HINT' | translate }}</span>
          </div>
          <span class="aca-ai-set__fixed">{{ 'DMS.ASSISTANT.WHO_ALL' | translate }}</span>
        </div>
        <div class="aca-ai-set__rule">
          <div>
            <strong>{{ 'DMS.ASSISTANT.CLOUD_LEVELS' | translate }}</strong
            ><span>{{ 'DMS.ASSISTANT.CLOUD_LEVELS_HINT' | translate }}</span>
          </div>
          <span class="aca-ai-set__checks">
            <label *ngFor="let level of levels">
              <input
                type="checkbox"
                [checked]="s.cloudAllowedLevels.includes(level.id)"
                [disabled]="saving()"
                (change)="toggleLevel(level.id, $any($event.target).checked)"
              />{{ level.label | translate }}
            </label>
          </span>
        </div>
        <div class="aca-ai-set__rule">
          <div>
            <strong>{{ 'DMS.ASSISTANT.AUTOCLASSIFY' | translate }}</strong
            ><span>{{ (s.enabled ? 'DMS.ASSISTANT.AUTOCLASSIFY_HINT' : 'DMS.ASSISTANT.AUTOCLASSIFY_NEEDS_ON') | translate }}</span>
          </div>
          <label class="aca-ai-set__switch">
            <input
              type="checkbox"
              [checked]="s.autoClassify"
              [disabled]="saving() || !s.enabled"
              (change)="setAutoClassify($any($event.target).checked)"
            />
            <span class="aca-ai-set__track" aria-hidden="true"></span>
            <span>{{ (s.autoClassify ? 'DMS.ASSISTANT.ON' : 'DMS.ASSISTANT.OFF') | translate }}</span>
          </label>
        </div>
        <div class="aca-ai-set__rule">
          <div>
            <strong>{{ 'DMS.ASSISTANT.INSIGHTS' | translate }}</strong
            ><span>{{ (s.enabled ? 'DMS.ASSISTANT.INSIGHTS_HINT' : 'DMS.ASSISTANT.INSIGHTS_NEEDS_ON') | translate }}</span>
          </div>
          <label class="aca-ai-set__switch">
            <input
              type="checkbox"
              [checked]="s.docInsights"
              [disabled]="saving() || !s.enabled"
              (change)="setDocInsights($any($event.target).checked)"
            />
            <span class="aca-ai-set__track" aria-hidden="true"></span>
            <span>{{ (s.docInsights ? 'DMS.ASSISTANT.ON' : 'DMS.ASSISTANT.OFF') | translate }}</span>
          </label>
        </div>
        <div class="aca-ai-set__rule">
          <div>
            <strong>{{ 'DMS.ASSISTANT.FORM_DRAFTS' | translate }}</strong
            ><span>{{ (s.enabled ? 'DMS.ASSISTANT.FORM_DRAFTS_HINT' : 'DMS.ASSISTANT.INSIGHTS_NEEDS_ON') | translate }}</span>
          </div>
          <label class="aca-ai-set__switch">
            <input
              type="checkbox"
              [checked]="s.formDrafts"
              [disabled]="saving() || !s.enabled"
              (change)="setFormDrafts($any($event.target).checked)"
            />
            <span class="aca-ai-set__track" aria-hidden="true"></span>
            <span>{{ (s.formDrafts ? 'DMS.ASSISTANT.ON' : 'DMS.ASSISTANT.OFF') | translate }}</span>
          </label>
        </div>
        <div class="aca-ai-set__rule">
          <div>
            <strong>{{ 'DMS.ASSISTANT.MAX_PAGES' | translate }}</strong
            ><span>{{ 'DMS.ASSISTANT.MAX_PAGES_HINT' | translate }}</span>
          </div>
          <input
            type="number"
            min="1"
            max="200"
            [value]="s.maxPagesPerQuestion"
            (change)="setNumber('maxPagesPerQuestion', $any($event.target).value)"
          />
        </div>
        <div class="aca-ai-set__rule">
          <div>
            <strong>{{ 'DMS.ASSISTANT.HISTORY_DAYS' | translate }}</strong
            ><span>{{ 'DMS.ASSISTANT.HISTORY_DAYS_HINT' | translate }}</span>
          </div>
          <input type="number" min="1" max="3650" [value]="s.historyDays" (change)="setNumber('historyDays', $any($event.target).value)" />
        </div>
      </div>
    </section>
  </ng-container>
</div>
